import React from "react";
import { Parallax } from "react-materialize";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  fullBleed: {
    position: "relative",
    width: "100vw",
    left: "50%",
    right: "50%",
    marginLeft: "-50vw",
    marginRight: "-50vw",
  },
});

const ParallaxBand = ({ imageSrc }) => {
  const classes = useStyles();

  return (
    <div className={classes.fullBleed}>
      <Parallax className="altoParalax" imageSrc={imageSrc} />
    </div>
  );
};

export default ParallaxBand;
